// extracted by mini-css-extract-plugin
export default {"dataPoint":"DataPointOrgan_dataPoint__y9aQk","dataPointInner":"DataPointOrgan_dataPointInner__pMdjd","descriptionPanelContainer":"DataPointOrgan_descriptionPanelContainer__krslR"};